import Quill from "quill";

const BlockEmbed = Quill.import("blots/block/embed");

class Divider extends BlockEmbed {
  static create(value) {
    const node = document.createElement("hr"); // 创建 <hr> 标签
    if (value && value.color) {
      node.style.height = "1px";
      node.style.border = "none";
      node.style.background = value.color;
    }
    return node;
  }

  static value(node) {
    return {
      color: node.style.borderColor || "#eee",
    };
  }
}

Divider.blotName = "divider"; // Blot 名称
Divider.tagName = "hr"; // 关联 HTML 标签

Quill.register(Divider); // 注册到 Quill



// WEBPACK FOOTER //
// ./src/plugins/quill/Divider.js